import { Stack, Typography } from '@mui/material';
import { Routes } from 'enums';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';
import { Contact } from 'types/contact.types';
import PaiButton from '../../ui/base-components/pai-button';
import PaiDotLoader from '../../ui/base-components/pai-dot-loader';
import PaiMenuItem from '../../ui/base-components/pai-menu-item';
import PaiSelect from '../../ui/base-components/pai-select';
import PersonalityType from './personality-type';

interface Props {
  profiles: Contact[];
  selectedProfile: string;
  assessment: Assessment | undefined;
  profileLoading: boolean;

  handleSelectedProfileChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

const TailoredProfileSelection: React.FC<Props> = ({ profiles, selectedProfile, assessment, profileLoading, handleSelectedProfileChange }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={classes.profileSelection}>
      <Stack className={classes.content} gap={!_.isNil(assessment) ? 1 : 4}>
        <Stack gap={2}>
          <div>
            <Typography className={classes.shortInstruction}>{t('selectTailoredProfile')}</Typography>
            <Typography className={classes.longInstruction}>{t('selectProfileInstructions')}</Typography>
          </div>
          <PaiSelect value={selectedProfile} disableBorder={true} onChange={handleSelectedProfileChange}>
            {profiles.map((profile) => (
              <PaiMenuItem key={profile.id} value={profile.id}>
                {profile.name}
              </PaiMenuItem>
            ))}
          </PaiSelect>
          {profileLoading ? <PaiDotLoader /> : null}
        </Stack>
        {!_.isNil(assessment) ? (
          <PersonalityType assessment={assessment} />
        ) : (
          <Stack gap={2}>
            <div>
              <Typography className={classes.shortInstruction}>{t('nothingSuitable')}</Typography>
              <Typography className={classes.longInstruction}>{t('profileCreationRequirements')}</Typography>
            </div>
            <PaiButton text={t('createOwnProfile')} action={() => navigate(Routes.PERSONA_GENERATOR)} fullWidth={true} />
          </Stack>
        )}
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  profileSelection: {
    height: 'calc(100% - 39px - 16px - 20px)',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    padding: '16px 16px 8px 16px',
  },
  content: {
    height: '100%',
    padding: '16px',
    overflow: 'auto',
  },
  shortInstruction: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginBottom: '8px',
  },
  longInstruction: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
    padding: '0 4px',
  },
}));

export default TailoredProfileSelection;
